/* global WP, Cookies, localStorage */
jQuery(document).ready(function ($) {

    //░░░░░░░░░░░░░░░░░░░░░░░░░░░
    //
    //    DIRECTORY
    //
    //    _ADA
    //    _Appointments
    //      ∟MatchHeights
    //      ∟Slider
    //    _Brands
    //      ∟MatchHeights
    //      ∟Slider
    //    _Header
    //      ∟StickyNav
    //      ∟Toggle
    //      ∟ToggleNav
    //    _SiteAlert
    //    _Search
    //    _ToggleList
    //      ∟Resize
    //    _ToggleSubNav
    //    _InsuranceChecker
    //    _Reviews
    //    _ScheduleOnline
    //
    //░░░░░░░░░░░░░░░░░░░░░░░░░░░

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser - Keydown Focus Class
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('body').on('keydown', function () {
        if (!$('.keyboard-in-use')[0]) {
            $(this).addClass('keyboard-in-use');
        }
    });

    $('body').on('mousedown', function () {
        if ($('.keyboard-in-use')[0]) {
            $(this).removeClass('keyboard-in-use');
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _ADA
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var $body = $('body'),
        $ada = $('.main-header__ada'),
        $toggleon = $ada.find('.fa-toggle-on'),
        $toggleoff = $ada.find('.fa-toggle-off');

    $ada.click(function () {
        $body.toggleClass('ada');
        $toggleoff.toggleClass('active inactive');
        $toggleon.toggleClass('active inactive');

        localStorage.setItem('ada', $body.hasClass('ada'));
    });

    $(window).load(function () {
        if (localStorage.getItem('ada') == 'true') {
            $ada.click();
        }
    });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ PagePopup
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('.page-popup')[0]) {

        $(window).on('load', function () {
            var id = $('.page-popup').attr('data-id');
            $('.lightbox').trigger('open', [$('.page-popup').clone(), false, false, 'dynamic', id]);
            $('.page-popup').attr('tab-index', '1');
        });

    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Appointments
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var appointment = $('.appointment__items'),
        item = $('.appointment__items .appointment__item');

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟MatchHeights
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $(item).matchHeights();

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Slider
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    if (appointment.length) {
        $(window).on('load resize', function () {
            if ($(window).width() > 768) {
                if (appointment.hasClass('slick-initialized')) {
                    appointment.slick('unslick');
                }
            } else if (!appointment.hasClass('slick-initialized')) {
                appointment.slick({
                    mobileFirst: true,
                    speed: 600,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: false,
                });
            }
        });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Brands
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var brands = $('.custom-brands .wrapper'),
        brand = $('.custom-brands .wrapper .item');

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟MatchHeights
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    brand.matchHeights({
        breakpoint: 768
    });


    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Slider
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    if (brands.length) {
        $(window).on('load resize', function () {
            if ($(window).width() > 768) {
                if (brands.hasClass('slick-initialized')) {
                    brands.slick('unslick');
                }
            } else if (!brands.hasClass('slick-initialized')) {
                brands.slick({
                    mobileFirst: true,
                    speed: 600,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: false,
                });
            }
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Header
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var header = $('.main-header'),
        controls = $('.toggle-controls'),
        mobile = $('.toggle-bar'),
        overlay = $('.toggle-bar__overlay'),
        body = $('body'),
        alert = $('.site-alert'),
        nav = $('.toggle-bar__wrapper .nav'),
        footerbutton = $('.footer-button');



    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟StickyNav
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $(window).on('load scroll', function () {
        var distance = $(window).scrollTop();

        if (distance > 100) {
            header.addClass('main-header__sticky');
        } else {
            header.removeClass('main-header__sticky');
        }
    });

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟StickyFooter
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $(window).on('load scroll', function () {
        var distance = $(window).scrollTop();

        if (distance > 300) {
            footerbutton.addClass('footer-button__sticky');
        } else {
            footerbutton.removeClass('footer-button__sticky');
        }
    });

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Toggle
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $(controls).click(function () {
        $(this).toggleClass('open');
        $(mobile).toggleClass('open');
        $(overlay).toggleClass('open');
        $(alert).toggleClass('open');
        $(body).toggleClass('fixed-content');
    });

    $(overlay).click(function () {
        $(this).removeClass('open');
        $(mobile).removeClass('open');
        $(overlay).removeClass('open');
        $(controls).removeClass('open');
        $(alert).removeClass('open');
        $(body).removeClass('fixed-content');
    });

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟ToggleNav
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    nav.find('.has-children').click(function (e) {
        if ($(window).width() <= 1150) {
            if (!$(this).hasClass('open')) {
                e.preventDefault();
                nav.find('.has-children.open').children('.sub-menu').slideUp();
                $(this).find('.sub-menu').slideDown();
                nav.find('.has-children').removeClass('open');
                $(this).addClass('open');
            }
        }
    });

    $(window).resize(function () {
        if ($(window).width() > 1150) {
            nav.removeClass('open');
            nav.find('.has-children').removeClass('open');
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _SiteAlert
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var $alert = $('.site-alert'),
        $singlealert = $('.site-alert__alert'),
        $exit = $alert.find('.button-exit');

    if ($alert.length) {
        $alert.on('refresh', function () {
            var height = Math.max($alert.outerHeight() - $(window).scrollTop(), 0);
            $alert.slideDown(200);
            header.css('top', height);
        });

        $(window).on('load resize scroll', function () {
            $singlealert.each(function () {
                var name = $(this).attr('name');

                if (!sessionStorage.getItem(name)) {
                    $(this).show();
                }
            });
            $alert.trigger('refresh');
        });

        $($exit).click(function () {
            var singlealert = $(this).parent(),
                name = singlealert.attr('name');

            sessionStorage.setItem(name, 'hidden');
            singlealert.hide();

            $alert.trigger('refresh');
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Search
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var iconsearch = $('.main-header__search .fa-search'),
        search = $('.main-header__search input');

    iconsearch.click(function () {
        search.toggleClass('active');
        search.parent().parent().toggleClass('active');
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _ToggleList
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var toggle = $('.toggle-list .toggle .title');

    toggle.click(function (event) {
        $(this).parent().toggleClass('expanded');
        $(this).siblings('.content').slideToggle('fast');
    });

    var read_more = $('.self-pay .service .service-read-more');

    read_more.click(function (event) {
        $(this).parent().siblings('.service-description').slideToggle('fast');
    });


    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Resize
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $(window).on('load resize', function () {
        if ($(window).width() > 1150) {
            mobile.removeClass('open');
            overlay.removeClass('open');
            controls.removeClass('open');
            body.removeClass('fixed-content');
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _ToggleSubNav
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var $subnav = $('.hero__subnav'),
        $subnavcontrols = $('.toggle-subnav'),
        $subnavwrapper = $('.toggle-subnav-wrapper');

    $subnavcontrols.click(function () {
        $(this).toggleClass('open');
        $subnav.slideToggle();
        $subnavwrapper.toggleClass('open');
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _InsuranceChecker
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    var $insurance = $('.insurance');

    if ($insurance.length) {

        var $state = $insurance.find('.js-state'),
            $region = $insurance.find('.js-region'),
            $location = $insurance.find('.js-location');

        var templates = {
            regions: $region.find('option[data-parent]').clone(),
            locations: $location.find('option[data-parent]').clone()
        };

        $state.change(function () {
            $region.hide();
            $region.val('');
            $region.find('option[data-parent]').remove();

            $location.empty();

            var state = $state.find('option').filter(':selected').val();

            if (state) {
                var $showing = templates.regions.filter('[data-parent="' + state + '"]');

                $region.append($showing);
                $region.show();
            }
        });

        $region.change(function () {
            $location.empty().hide();

            var region = $region.find('option').filter(':selected').val();

            if (region) {
                $location.html('<div class="toggle fake"><p class="title">Loading...<span class="icon"><span class="wrapper"></span></span></p></div>').fadeIn();
                $.post(WP.ajaxurl, { action: WP.actions.get_location_insurance, term_id: region }, function (response) {
                    if (response.success) {
                        $location.html(response.data.html);

                        $location.find('.toggle .title').click(function (event) {
                            $(this).parent().toggleClass('expanded');
                            $(this).siblings('.content').slideToggle('fast');
                        });
                    }
                });
            }
        });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Reviews
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var reviews = $('.reviewslider .reviewslider__wrapper');

    if (reviews.length) {
        $(window).on('load resize', function () {
            if ($(window).width() < 200) {
                if (reviews.hasClass('slick-initialized')) {
                    reviews.slick('unslick');
                }
            } else if (!reviews.hasClass('slick-initialized')) {
                reviews.slick({
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerMode: true,
                    speed: 600,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    adaptiveHeight: true,
                    responsive: [{
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
            }
        });
    }




    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Schedule Online
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    $(document).on('click', 'a.coronavirus', function (e) {
        var $content = $(this).parent().find('div.coronavirus');

        if ($content.length) {
            e.preventDefault();

            $('.lightbox').trigger('open', [$content.clone()]);
        }
    });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ JSPDF
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('.item-pdf-download')[0]) {

        $('.item-pdf-download').click(function () {
            const source = $('.form-page.treatment-authorization .container.narrow');

            if (!source[0]) return;

            var opt = {
                margin: [5, 5, 5, 5],
                filename: 'treatment-authorization.pdf',
                image: {
                    type: 'jpeg',
                    quality: 1
                },
                html2canvas: { scale: 1, scrollY: 0 },
                pageBreak: { mode: ['avoid-all', 'css'] },
                jsPDF: {
                    orientation: 'portrait',
                    unit: 'mm',
                    format: 'letter',
                }
            }

            html2pdf().set(opt).from(source[0]).outputPdf('blob').save();
        });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ ScheduleOnline
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    jQuery(window).on('load', function () {
        var $location = jQuery('.location, .center.js-center');
        var $schedule_start = $location.data('hide-schedule-start');
        var $schedule_end = $location.data('hide-schedule-end');
        var $now = new Date();
        var $start = new Date($schedule_start);
        var $end = new Date($schedule_end);

        if ($now >= $start && $now <= $end) {
            $('.schedule-button-wrapper').empty().append('<p>Online scheduling is not available; please call for more information.</p>');
        }
    });
});
